import { Modal } from "antd";
import { allCommonImages } from "../../Assets/Images/images";
import { appName } from "../../helpers/utils";
import { CloseIcon } from "../../Components/Components";
import React from "react";
import { EmailTemplateI } from "../Types/state/emailTemplate.state";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//email template view model
interface TemplatePreview {
  modalOpen: boolean;
  addHandler: any;
  cancelHandler: () => void;
  updateData: EmailTemplateI | undefined;
}

export const EmailTemplatePreview: React.FC<TemplatePreview> = ({
	modalOpen,
	addHandler,
	cancelHandler,
	updateData,
  }) => {
	const cancelSuperHandler = (e: any) => {
	  e.preventDefault();
	  cancelHandler();
	};
	const thanksText = "JOHANSON BOATWORKS";
	const headerBgColor = "#e8faff";
	const footerBgColor = "#ffffff";
	const bgColor = "#ffffff";
	const textColor = "#000000";
	const html = `<!DOCTYPE html>
  <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
		  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
		  <title>${appName}</title>
  
		  <link rel="preconnect" href="https://fonts.googleapis.com">
		  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
		  <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
      <style>
          *,
			  ::after,
			  ::before {
				  box-sizing: border-box;
			  }
			  body {
				  font-family: 'Montserrat', sans-serif;
				  margin: 0;
				  padding: 0;
				  -webkit-text-size-adjust: 100%;
				  -ms-text-size-adjust: 100%;
				  word-break: break-word;
			  }
			  table,
			  td {
				  border-collapse: collapse;
				  mso-table-lspace: 0pt;
				  mso-table-rspace: 0pt;
			  }
			  img {
				  border: 0;
				  height: auto;
				  line-height: 100%;
				  outline: none;
				  text-decoration: none;
				  -ms-interpolation-mode: bicubic;
			  }
  
      </style>
    </head>
    <body style="background-color: #f6f6f6; font-family: 'Montserrat', sans-serif; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 0; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%;">
		  <span class="preheader" style="color: transparent; display: none; height: 0; max-height: 0; max-width: 0; opacity: 0; overflow: hidden; mso-hide: all; visibility: hidden; width: 0;">This is preheader text. Some clients will show this text as a preview.</span>
		  <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="body" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #f6f6f6; width: 100%;" width="100%" bgcolor="#f6f6f6">
			  <tr>
				  <td style="font-family: 'Montserrat', sans-serif; font-size: 14px; vertical-align: top;" valign="top">&nbsp;</td>
				  <td class="container" style="font-family: 'Montserrat', sans-serif; font-size: 14px; vertical-align: top; display: block; max-width: 600px; width: 600px; margin: 0 auto;background: ${bgColor};" width="580" valign="top">
  
					  <div class="content" style="box-sizing: border-box; display: block; margin: 1rem auto; max-width: 600px; padding: 20px 10px;">
  
						  <!--START HEADER-->
						  <div class="header" style="text-align: center;padding: 0 0 1rem;">
							  <a href="javascript:;" style="display: inline-block">
								  <img src="${allCommonImages.LogoWhite}" width="206" height="50" style="object-fit: contain;" alt="${appName}"/>
							  </a>
						  </div>
						  <!--END HEADER-->
  
                  <!-- Add Body Here Start -->
                  ${updateData?.html_template}
  
  
                  <!-- Add Body Here End -->
  
                   <!-- START FOOTER -->
						  <div class="footer" style="clear: both; margin-top: 20px; text-align: center; width: 100%;">
							  <table role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;" width="100%">
								  <tr>
									  <td class="content-block powered-by" style="font-family: 'Montserrat', sans-serif; vertical-align: top; padding-bottom: 0; padding-top: 0; color: #999999; font-size: 12px; text-align: center;" valign="top" align="center">
										  <div style="text-align: center;">
											  <p style="font-family: 'Montserrat', sans-serif; font-size: 16px; font-weight: 600; margin: 0; margin-bottom: 5px;color: #CD9E13">Thanks</p>
											  <p style="font-family: 'Montserrat', sans-serif; font-size: 16px; font-weight: 500; margin: 0; margin-bottom: 0; color: ${textColor};">${thanksText}</p>
										  </div>
									  </td>
								  </tr>
							  </table>
						  </div>
						  <!-- END FOOTER -->
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </body>
  </html>`;
  
	return (
	  <Modal
		open={modalOpen}
		onOk={addHandler}
		onCancel={cancelSuperHandler}
		footer={[]}
		maskClosable={false}
		className={`adminModal antdModal`}
		closable={true}
		centered={true}
		closeIcon={<CloseIcon />}
		width={768}
	  >
		<h4 className="antdModalTitle">{updateData?.title}</h4>
		<div className="border border-2 my-3">
		  <iframe srcDoc={html} className="d-block" loading={"lazy"} style={{ height: 700, width: "100%" }} />
		</div>
	  </Modal>
	);
  };
   

export const BackButton = ({ path, text }: any) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <span
      onClick={() => navigate(path ? path : -1)}
      className="back-btn-link d-inline-block text-primary fw-medium fs-5 mb-0 me-2 cursor-pointer"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.7999 10.7464L4.0965 10.7464L10.4482 4.02836C10.5628 3.91128 10.6542 3.77123 10.7171 3.61638C10.78 3.46153 10.8131 3.29498 10.8145 3.12645C10.8159 2.95792 10.7855 2.79079 10.7252 2.63481C10.6648 2.47882 10.5757 2.33711 10.463 2.21794C10.3504 2.09877 10.2164 2.00452 10.0689 1.94071C9.92143 1.87689 9.76342 1.84477 9.60408 1.84624C9.44474 1.8477 9.28728 1.88272 9.14087 1.94924C8.99447 2.01576 8.86205 2.11245 8.75135 2.23367L0.351263 11.1183C0.126296 11.3563 -8.39233e-05 11.6791 -8.39233e-05 12.0156C-8.39233e-05 12.3522 0.126296 12.675 0.351263 12.913L8.75135 21.7976C8.97768 22.0288 9.2808 22.1567 9.59544 22.1538C9.91008 22.1509 10.2111 22.0175 10.4336 21.7821C10.656 21.5468 10.7822 21.2285 10.785 20.8957C10.7877 20.5629 10.6668 20.2423 10.4482 20.0029L4.0965 13.2849L22.7999 13.2849C23.1182 13.2849 23.4234 13.1511 23.6484 12.9131C23.8735 12.6751 23.9999 12.3523 23.9999 12.0156C23.9999 11.679 23.8735 11.3562 23.6484 11.1182C23.4234 10.8801 23.1182 10.7464 22.7999 10.7464Z"
          fill="#000"
        />
      </svg>
      {text ? t("button.back") : ""}
    </span>
  );
};
